export default __webpack_public_path__ + "static/media/blocking.94a2e1e0.png";